import React from 'react'
import classNames from 'classnames'

import EmailSignupForm from 'components/email-signup-form'
import {
  USER_SOURCE_EMAIL_PREGNANCY_WIDGET,
  USER_SOURCE_EMAIL_NEWSLETTER_WIDGET,
} from 'shared/constants'
import * as css from './email-callout.scss'

export enum EmailTypes {
  Pregnancy = 'pregnancy',
  Newsletter = 'newsletter',
}

interface EmailCalloutProps {
  emailType: EmailTypes
  emailUrlsByWeek: string[]
  nextPost: { slug: string; title: string }
}

export const EmailCallout = ({
  emailType,
  emailUrlsByWeek,
  nextPost,
}: EmailCalloutProps) => {
  let containerClass, userSource, descriptionText

  switch (emailType) {
    case EmailTypes.Pregnancy:
      containerClass = css.emailSignupPregnancy
      userSource = USER_SOURCE_EMAIL_PREGNANCY_WIDGET
      descriptionText = 'Keep your pregnancy on track. One email a week.'
      break
    case EmailTypes.Newsletter:
      containerClass = css.emailSignupGeneral
      userSource = USER_SOURCE_EMAIL_NEWSLETTER_WIDGET
      descriptionText =
        'The freshest in parenting this week, delivered to your inbox'
      break
  }

  return (
    <div
      className={classNames(
        containerClass,
        css.emailSignupContainer,
        'clearfix flex-vertical-center center-block mbxl'
      )}
    >
      <div className={classNames(css.leftContainerBackground, 'hidden-xs')} />
      <div className={css.formContainer}>
        <div className="h5 text-bold">{descriptionText}</div>
        <EmailSignupForm
          nextPost={nextPost}
          emailUrlsByWeek={emailUrlsByWeek}
          emailType={emailType}
          userSource={userSource}
        />
      </div>
    </div>
  )
}

export default EmailCallout
